import { STAFF_DASHBOARD } from '@brickup/shared/locales/de/staff-dashboard'
import { ActiveProjectsPanel } from './ActiveProjectsPanel'
import { ActivityPanel } from './ActivityPanel'
import { DashboardData } from './DashboardLayout'
import { useProjectsDashboard } from '@/api/staff-dashboard'

/**
 * What a project manager and a site manager open on: the projects they are
 * named on, and what moved on them.
 *
 * The advisor's dashboard beside this one carries the customer half as well —
 * the mandates, the quiet customers, the matching — which is work these roles
 * do not do. Both panels are the same components, so the two cannot drift.
 *
 * @single-use the `projects` tab of the staff dashboard.
 */
export function ProjectsDashboard() {
  const query = useProjectsDashboard()

  return (
    <DashboardData query={query}>
      {data => (
        <>
          <ActiveProjectsPanel
            statusCounts={data.statusCounts}
            projects={data.projects}
          />
          <ActivityPanel
            subtitle={STAFF_DASHBOARD.projects.activityHint}
            activity={data.activity}
            activityCount={data.activityCount}
          />
        </>
      )}
    </DashboardData>
  )
}
